module.exports = __webpack_public_path__ + "static/media/enchanting.2e2b837f.png";